import { getApiErrorDetails } from '@a6tr/lib/apiError';
import * as Sentry from '@sentry/react';
import type { ErrorComponentProps } from '@tanstack/react-router';
import {
	createRootRoute,
	ErrorComponent,
	Outlet,
} from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthGate } from '@/domains/authentication/components/AuthGate';

const RootLayout = () => (
	<AuthGate>
		<Outlet />
		<TanStackRouterDevtools position="bottom-right" />
	</AuthGate>
);

const RootErrorComponent = ({ error }: ErrorComponentProps) => {
	const { t } = useTranslation();
	const { requestId, codeName } = getApiErrorDetails(error);

	useEffect(() => {
		Sentry.captureException(error, {
			tags: { request_id: requestId, connect_code: codeName },
		});
	}, [error, requestId, codeName]);

	return (
		<div className="flex flex-col gap-2 p-4">
			<ErrorComponent error={error} />
			{requestId && (
				<p className="typography-text-s text-neutral-gray-800">
					{t('common.api.referenceLabel')}:{' '}
					<span className="select-all">{requestId}</span>
				</p>
			)}
		</div>
	);
};

export const Route = createRootRoute({
	component: RootLayout,
	errorComponent: RootErrorComponent,
});
